import { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { API_STREAM_DATA } from '../api';

const useFetch = () => {
  const [streamLink, setStreamLink] = useState(null);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Ref visada laiko naujausią streamLink reikšmę — išvengiamas stale closure
  // setInterval viduje, kuris kitaip visada matytų pirmojo renderio reikšmę
  const streamLinkRef = useRef(null);

  const getData = useCallback(async () => {
    try {
      const streamData = await axios.get(API_STREAM_DATA);
      const source = streamData.data.icestats.source[0];

      if (streamLinkRef.current === null) {
        streamLinkRef.current = source.listenurl;
        setStreamLink(source.listenurl);
      }

      // Perrenderinamas tik keičiantis dainai — ne kiekvieną 5 sekundę
      setData((prev) => {
        if (prev.yp_currently_playing === source.yp_currently_playing) return prev;
        return source;
      });

      setIsLoading(false);
      setError(null);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  }, []);

  const retry = useCallback(() => {
    setIsLoading(true);
    setError(null);
    getData();
  }, [getData]);

  useEffect(() => {
    getData();
    const interval = setInterval(getData, 5000);
    return () => clearInterval(interval);
  }, [getData]);

  return [isLoading, data, error, streamLink, retry];
};

export default useFetch;
